'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PushCart = require('./PushCart/PushCart');

var _PushCart2 = _interopRequireDefault(_PushCart);

var _RecentlyViewedProducts = require('./RecentlyViewedProducts/RecentlyViewedProducts');

var _RecentlyViewedProducts2 = _interopRequireDefault(_RecentlyViewedProducts);

var _Customiser = require('./Customiser/Customiser');

var _Customiser2 = _interopRequireDefault(_Customiser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  PushCart: _PushCart2.default,
  RecentlyViewedProducts: _RecentlyViewedProducts2.default,
  Customiser: _Customiser2.default
};